import * as React from "react";
import {
  Paper,
  Stack,
  Typography,
  Button,
  useTheme,
  alpha,
} from "@mui/material";
import { useConsent } from "./ConsentProvider";
import { useTranslate } from "src/locales";

export default function CookieBanner() {
  const { t } = useTranslate();
  const theme = useTheme();
  const { isDecided, consent, setConsent, openPreferences } = useConsent();
  if (isDecided) return null;

  const acceptAll = () =>
    setConsent({ ...consent, analytics: true, marketing: true });
  const rejectAll = () =>
    setConsent({ ...consent, analytics: false, marketing: false });

  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        left: 16,
        right: 16,
        bottom: 16,
        mx: "auto",
        maxWidth: 880,
        p: 2.5,
        borderRadius: 3,
        zIndex: 1300,
        bgcolor: alpha(theme.palette.background.paper, 0.95),
        backdropFilter: "blur(8px)",
      }}
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie_consent_banner")}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ sm: "center" }}
        justifyContent="space-between"
      >
        <Typography variant="body1" sx={{ pr: { sm: 2 } }}>
          {t("cookies_message")}{" "}
          {/* e.g. "We use cookies to improve your experience..." */}
        </Typography>

        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={1.5}
          justifyContent="flex-end"
          flexShrink={0}
          flexWrap="wrap"
        >
          {/* <Button variant="outlined" color="inherit" onClick={rejectAll}>
            {t("reject_non_essential")}
          </Button> */}
          <Button variant="contained" color="success" onClick={acceptAll}>
            {t("accept_all")}
          </Button>
          <Button variant="outlined" onClick={openPreferences}>
            {t("customize")}
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
